// @ vendor
const Immutable = require('immutable');

// @ constants
const { DOCUMENT_TYPES } = require('../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_SET_DATA,    
    INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_FAILURE,
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => {
    const documents = Object.keys(DOCUMENT_TYPES).map(() => {
        return {
            isFetching: false,
            error: ''
        }
    });

    return Immutable.Map().merge({
        valid: false,
        validUI: false,
        fieldErrors: false,
        acceptedConditions: false,
        summary: null,
        isFetchingSummary: false,
        documents,
        prevInsuranceId: null
    });
};

const validateStep = step => {
    const acceptedConditions = step.get('acceptedConditions');
    return step.merge({
        valid: true,
        validUI: acceptedConditions,
        fieldErrors: !acceptedConditions
    });
};

const insuranceRequestRelatedRNCWizardStep5 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_VALIDATE_STEP:
            return validateStep(state);

        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_SET_DATA:
            return state.merge({
                ...action.data,
                validUI: false,
                valid: false
            });

        case INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_REQUEST:
            return state.merge({
                documents: {
                    [action.data.docType]: { isFetching: true }
                }
            });

        case INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_SUCCESS:
            return state.merge({
                documents: {
                    [action.data.docType]: { isFetching: false }
                }
            });

        case INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_FAILURE:
            return state.merge({
                documents: {
                    [action.data.docType]: {
                        isFetching: false,
                        error: action.data.error
                    }
                }
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestRelatedRNCWizardStep5;
